import React from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16">
      <div className="w-full max-w-md rounded-xl border border-mcc-lightest/60 bg-white p-8 shadow-2xl">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-mcc-darkest">
            Reset password
          </h2>
          <p className="mt-2 text-sm text-slate-600">
            Continue to the secure sign-in page, then choose “Forgot password”.
          </p>
        </div>

        <Link
          to="/login"
          className="mt-8 block w-full rounded-md bg-mcc-neutral py-2.5 text-center text-sm font-semibold text-white shadow-md"
        >
          Continue
        </Link>

        <p className="mt-6 text-center text-sm text-slate-600">
          Remember your password?{' '}
          <Link
            to="/login"
            className="font-medium text-mcc-neutral transition-colors hover:text-mcc-darkest hover:underline"
          >
            Back to Sign In
          </Link>
        </p>
      </div>
    </div>
  );
}
